

var React = require("react");
var _ = require("underscore");


class Pagintation extends React.Component {

    constructor() {
        super();
    }

    changePage(page) {
        if(this.props.onPageChangeHandler) {
            this.props.onPageChangeHandler(page);
        }
    }

    changeToNextPage() {
        var totalPages = Math.ceil(this.props.total / this.props.pageSize);
        var nextPage = this.props.currentPage + 1;
        if(nextPage > totalPages - 1) {
            // do nothing
        } else {
            this.changePage(nextPage);
        }
    }

    changeToPreviousPage() {
        var previousPage = this.props.currentPage - 1;
        if(previousPage < 0) {
            // do nothing
        } else {
            this.changePage(previousPage);
        }
    }

    getPager(totalItems, currentPage, pageSize) {

        var pageStart = 0;
        var totalPages = Math.ceil(totalItems / pageSize);
        var pageEnd = totalPages - 1;
        var displaySize = this.props.displaySize || 9;
        var halfDisplaySize = Math.floor(displaySize / 2);
        if (totalPages > displaySize) {
            pageStart = currentPage - halfDisplaySize;
            pageStart = pageStart < 0 ? 0 : pageStart;
            pageEnd = currentPage + halfDisplaySize;
            pageEnd = pageEnd > totalPages - 1 ? totalPages - 1 : pageEnd;

            // Adjust pageStart and pageEnd to make it to displaySize
            if(pageEnd == totalPages - 1) {
                pageStart = totalPages - displaySize;
            } else if (pageStart == 0) {
                pageEnd = displaySize - 1;
            }
        }

        var items = [];
        var self = this;

        for (var i = pageStart; i <= pageEnd; i++) {
            var active = i == currentPage ? "active" : "";
            items.push(<li key={i} className={`item ${active}`} onClick={(function(page) {return () => self.changePage(page)})(i)}>{i + 1}</li>);
        }

        return items;
    }

    render() {
        if (this.props) {
            var pages = this.getPager(this.props.total, this.props.currentPage, this.props.pageSize);

            return (
                <ul className="pagination">
                    <li className="item" onClick={this.changeToPreviousPage.bind(this)} title="Previous Page">&lt;</li>
                    {pages}
                    <li className="item" title="Next Page" onClick={this.changeToNextPage.bind(this)}>&gt;</li>
                </ul>
            );
        } else {
            return (<ul></ul>);
        }
    };
}

module.exports = Pagintation;
 